import { FC } from 'react';

export interface CreditCheckBadgeStatusProps {
  numberOfKO?: number;
}
export type CreditCheckBadgeProps = CreditCheckBadgeStatusProps;
export const CreditCheckBadgeComponent: FC<CreditCheckBadgeProps> = ({ numberOfKO }) => {
  const color = numberOfKO === undefined ? 'secondary' : numberOfKO === 0 ? 'success' : 'warning';
  const text = numberOfKO === undefined ? '-' : numberOfKO;

  return (
    <span data-e2e="credit-check-badge">
      <span className={`badge rounded-pill badge-${color} ms-3`}>{`KO Credit check: ${text}`}</span>
      {numberOfKO === undefined && <i className="icon icon-sm icon-spin ms-1 text-secondary">autorenew</i>}
    </span>
  );
};
